import { render } from "./upcoming-deliveries.vue?vue&type=template&id=5f333a00"
import script from "./upcoming-deliveries.vue?vue&type=script&lang=js"
export * from "./upcoming-deliveries.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__